// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*** IMAGE POSITION OPTION: Left/Right ***/
@media screen and (max-width: 719px) { /* mobile */
  .grid__inner .grid-item .grid-item__inner.image_left_right {
    display: flex;
    height: unset;
    flex-direction: column;
  }
  .grid__inner .grid-item .grid-item__inner.image_left_right > .image,
  .grid__inner .grid-item .grid-item__inner.image_left_right > .grid-item__text-container-wrapper {
    min-height: var(--mobile-height);
    width: 100%;
    position: relative;
  }
}
@media screen and (min-width: 720px) { /* desktop */
  .grid__inner .grid-item:nth-of-type(odd) .grid-item__inner.image_left_right > .image {
    order: 1;
  }
  .grid__inner .grid-item .grid-item__inner.image_left_right {
    display: flex;
    flex-direction: row;
  }
  .grid__inner .grid-item .grid-item__inner.image_left_right > .image,
  .grid__inner .grid-item .grid-item__inner.image_left_right > .grid-item__text-container-wrapper {
    width: 50%;
    position: relative;
  }
}
.grid-item__text-container-wrapper {
  word-break: break-word;
  position: relative;
}

.grid-item.height-fits-content {
  min-height: 0;
}

.grid-item.height-fits-content .grid-item__text-container-wrapper {
  padding: var(--mobile-padding-height-fits-content);
}

@media (min-width: 720px) {
  .grid-item.height-fits-content .grid-item__text-container-wrapper {
    padding: var(--padding-height-fits-content);
  }
}
.grid-container {
  position: absolute;
  height: 100%;
  width: 100%;
}
.grid-container .grid-item-absolute-image-wrapper {
  position: absolute;
  height: var(--absolute-image-size);
  width: var(--absolute-image-size);
  top: calc(var(--absolute-image-top) - var(--absolute-image-size) / 2);
  left: calc(var(--absolute-image-left) - var(--absolute-image-size) / 2);
}
@media screen and (max-width: 719px) {
  .grid-container .grid-item-absolute-image-wrapper { /* mobile */
    height: var(--absolute-mobile-image-size);
    width: var(--absolute-mobile-image-size);
    top: calc(var(--absolute-mobile-image-top) - var(--absolute-mobile-image-size) / 2);
    left: calc(var(--absolute-mobile-image-left) - var(--absolute-mobile-image-size) / 2);
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/grid-item.scss"],"names":[],"mappings":"AAAA,0CAAA;AA4CA,uCAAA,WAAA;EA3BQ;IACE,aAAA;IAGE,aAAA;IACA,sBAAA;EAhBV;EAqBQ;;IAGI,gCAAA;IACA,WAAA;IAKF,kBAAA;EAxBV;AACF;AAmCA,uCAAA,YAAA;EA1CU;IAEI,QAAA;EASZ;EAAM;IACE,aAAA;IAME,mBAAA;EAHV;EAMQ;;IAMI,UAAA;IAGF,kBAAA;EAVV;AACF;AAyBA;EACE,sBAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,aAAA;AAvBF;;AA0BA;EACE,kDAAA;AAvBF;;AA0BA;EACE;IACE,2CAAA;EAvBF;AACF;AA0BA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAxBF;AA0BE;EACE,kBAAA;EACA,kCAAA;EACA,iCAAA;EACA,qEAAA;EACA,uEAAA;AAxBJ;AA0BI;EAPF,oDAOyC,WAAA;IACrC,yCAAA;IACA,wCAAA;IACA,mFAAA;IACA,qFAAA;EAvBJ;AACF","sourcesContent":["/*** IMAGE POSITION OPTION: Left/Right ***/\n@mixin image_left_right($is_mobile: false) {\n  .grid__inner {\n    .grid-item:nth-of-type(odd) {\n      .grid-item__inner {\n        &.image_left_right {\n          > .image {\n            @if not $is_mobile {\n              order: 1;\n            }\n          }\n        }\n      }\n    }\n\n    .grid-item {\n      .grid-item__inner {\n        &.image_left_right {\n          display: flex;\n\n          @if $is_mobile {\n            height: unset;\n            flex-direction: column;\n          } @else {\n            flex-direction: row;\n          }\n\n          > .image,\n          > .grid-item__text-container-wrapper {\n            @if $is_mobile {\n              min-height: var(--mobile-height);\n              width: 100%;\n            } @else {\n              width: 50%;\n            }\n\n            position: relative;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 719px) { /* mobile */\n  @include image_left_right($is_mobile: true);\n}\n\n@media screen and (min-width: 720px) { /* desktop */\n  @include image_left_right();\n}\n\n.grid-item__text-container-wrapper {\n  word-break: break-word;\n  position: relative;\n}\n\n.grid-item.height-fits-content {\n  min-height: 0;\n}\n\n.grid-item.height-fits-content .grid-item__text-container-wrapper {\n  padding: var(--mobile-padding-height-fits-content);\n}\n\n@media (min-width: 720px) {\n  .grid-item.height-fits-content .grid-item__text-container-wrapper {\n    padding: var(--padding-height-fits-content);\n  }\n}\n\n.grid-container {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n\n  .grid-item-absolute-image-wrapper {\n    position: absolute;\n    height: var(--absolute-image-size);\n    width: var(--absolute-image-size);\n    top: calc(var(--absolute-image-top) - (var(--absolute-image-size) / 2));\n    left: calc(var(--absolute-image-left) - (var(--absolute-image-size) / 2));\n\n    @media screen and (max-width: 719px) { /* mobile */\n      height: var(--absolute-mobile-image-size);\n      width: var(--absolute-mobile-image-size);\n      top: calc(var(--absolute-mobile-image-top) - (var(--absolute-mobile-image-size) / 2));\n      left: calc(var(--absolute-mobile-image-left) - (var(--absolute-mobile-image-size) / 2));\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
